declare var $: any;
declare var window: any;

export class Generic {
    static getInstance() {
        if (!Generic.instance) {
            Generic.instance = new Generic();
        }
        return Generic.instance;
    }

    private static instance: Generic;

    public getPageTypes() {
        const pageTypes = {
            personal: [
                '/concierge-service.html',
                '/consumer-secure-file-storage.html',
                '/family-plan.html',
                '/personal.html',
                '/personal-breachwatch.html',
            ],
            business: [
                '/advanced-reporting-alerts-module.html',
                '/breachwatch.html',
                '/business.html',
                '/compliance-reports.html',
                '/connection-manager.html',
                '/enterprise.html',
                '/government-cloud/',
                '/keeperchat.html?tab=personal&t=b',
                '/msp-password-manager.html',
                '/privileged-access-management/',
                '/professional-services-business.html',
                '/secrets-manager.html',
                '/secrets-manager.html',
                '/secure-file-storage.html',
                '/solutions/enterprise-password-management/',
                '/solutions/industry-compliance-reporting/',
                '/solutions/password-rotation/',
                '/solutions/passwordless-authentication/',
                '/solutions/privileged-session-management/',
                '/solutions/remote-database-access/',
                '/solutions/remote-infrastructure-access/',
                '/solutions/remote-privileged-access-management/',
                '/solutions/role-based-access-control/',
                '/solutions/single-sign-on/',
                '/solutions/ssh-key-management/',
                '/solutions/zero-trust-security/',
            ],
            bp: [
                '/affiliate/business/',
                '/affiliate/keeper-30OFFDeals.html',
                '/affiliate/keeper-50off-unlimited.html',
                '/affiliate/personal-and-business/',
                '/device-approval-keeper-push/',
                '/features/',
                '/features/browser-extension/',
                '/features/password-sharing/',
                '/features/TOTP-generator/',
                '/highest-rated-password-manager/',
                '/password-manager-reviews/',
                '/password-sharing-safely/',
                '/passwords-at-risk/',
                '/passwords-at-risk/affiliate/',
                '/resources/zero-knowledge-for-ultimate-password-security/',
            ],
            home: ['/index.html'],
        };

        return pageTypes;
    }

    public whatPageType = (url: string) => {
        for (const [key, values] of Object.entries(this.getPageTypes())) {
            if (values.includes(url)) {
                return key;
            }
        }
        return 'general'; // Default to 'general' if the URL is not found in any category
    };
}

export default Generic;
